import React, { useState } from "react";
import {
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";
import "./CheckoutForm.css";

interface CheckoutFormProps {
  amount: number;
  onClose: () => void;
}

const CheckoutForm: React.FC<CheckoutFormProps> = ({ amount, onClose }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!stripe || !elements) return;

    setLoading(true);
    const result = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: window.location.href, // Optional, for redirection after payment
      },
      redirect: "if_required", // avoid redirect if not needed
    });

    setLoading(false);

    if (result.error) {
      setError(result.error.message || "Payment failed");
    } else if (result.paymentIntent) {
      setError(null);

      const status = result.paymentIntent.status;

      if (status === "succeeded") {
        alert("Payment successful!");
        window.location.href = "/success"; // Redirect to success page

        onClose();
      } else if (status === "processing") {
        // alert("Payment is processing. You’ll be notified when it completes.");
        // onClose();
      } else {
        setError(`Payment status: ${status}`);
      }
    }
  };

  return (
    <form className="stripe-checkout-form" onSubmit={handleSubmit}>
      <h3 className="stripe-checkout-title">Pay ${amount.toFixed(2)}</h3>
      <div className="stripe-card-element">
        <PaymentElement />
      </div>
      {error && <div className="stripe-error">{error}</div>}
      <button
        type="submit"
        className="stripe-pay-btn"
        disabled={!stripe || loading}
      >
        {loading ? "Processing..." : "Pay Now"}
      </button>
    </form>
  );
};

export default CheckoutForm;
